import FilterTypeOptions from "~/pages/app/config/options/filter_type";
export default [
    ...FilterTypeOptions
]